import { PrivateNote } from 'components/molecules/tasks/details/private-note';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacPrivateNoteEditor = withAccess(PrivateNote.Editor);
export const RbacPrivateNoteTitle = withAccess(PrivateNote.Title);
